import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHistoryMapComponent } from './tractors-history-map.component';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {DxLoadPanelModule} from 'devextreme-angular';
import {MapLayersControlModule} from '../../map/map-layers-control/map-layers-control.module';



@NgModule({
  declarations: [TractorsHistoryMapComponent],
    imports: [
        CommonModule,
        LeafletModule,
        DxLoadPanelModule,
        MapLayersControlModule
    ],
  exports: [TractorsHistoryMapComponent]
})
export class TractorsHistoryMapModule { }
